import { defineComponent as _defineComponent } from 'vue'
import AppExpandableSection from "@/components/AppExpandableSection.vue";
import NationalAnalysisEventsChart from "@/components/NationalAnalysisEventsChart.vue";
import NationalAnalysisFormsChart from "@/components/NationalAnalysisFormsChart.vue";
import NationalAnalysisClaimsChart from "@/components/NationalAnalysisClaimsChart.vue";
import NationalScatterChart from "@/components/NationalScatterChart.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NationalAnalysisView',
  setup(__props) {


return { __sfc: true,AppExpandableSection, NationalAnalysisEventsChart, NationalAnalysisFormsChart, NationalAnalysisClaimsChart, NationalScatterChart }
}

})